// Shared API URL configuration for all components
// In production: uses relative URLs (nginx proxies to backend)
// In local dev mode (port 3002): uses consolidated server on port 3000

// All APIs now use the same consolidated server
export const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' && window.location.port === '3002'
    ? 'http://localhost:3000/api'
    : '/api');

// Users API uses the same consolidated server
export const USERS_API_URL = API_URL;

// Helper to get the appropriate API URL
export const getApiUrl = () => API_URL;
export const getUsersApiUrl = () => USERS_API_URL;
